import styled from 'styled-components';

export const PaginationPadding = styled.div`
  padding: 0.5rem 2rem;
`;
